import { UseQueryResult } from '@tanstack/react-query';

import { API_QUERY_KEYS, getLateResponsesReport, useBaseReport } from 'api';
import { ReportResponse } from 'types';

export const useLateResponsesReport = (): UseQueryResult<ReportResponse> =>
  useBaseReport(API_QUERY_KEYS.getLateResponsesReport, getLateResponsesReport);
